<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';

const props = defineProps<{
  property: PropertyOnPage
}>();

const { t, n } = useI18n();
const { amount } = useIadFormat();

const coOwnership = toRef(() => props.property.coOwnership);
const unitsCounts = computed(() => {
  return coOwnership.value.unitsCount
    ? n(coOwnership.value.unitsCount)
    : t(`property.co_ownership.not_available`);
});
const annualFees = computed(() => {
  return coOwnership.value.annualFees
    ? t(`property.co_ownership.annual_fees_yearly`, { amount: amount(coOwnership.value.annualFees) })
    : t(`property.co_ownership.not_available`);
});
const proceedingsUnderway = computed(() => {
  return coOwnership.value.proceedingsUnderway == null
    ? t(`property.co_ownership.not_available`)
    : t(`property.co_ownership.proceedings_underway_value`, { count: coOwnership.value.proceedingsUnderway ? 1 : 2 });
});
</script>

<template>
  <section class="pt-2xl">
    <IadTitle
      tag="h3"
      :text="$t(`property.co_ownership.information`)"
      class="mb-s"
    />
    <div class="border border-neutral-70 p-m rounded-xl flex flex-col gap-s">
      <dl class="flex gap-m justify-between">
        <dt v-text="$t(`property.co_ownership.unit_count`)" />
        <dd v-text="unitsCounts" />
      </dl>
      <dl class="flex gap-m justify-between">
        <dt v-text="$t(`property.co_ownership.annual_fees`)" />
        <dd v-text="annualFees" />
      </dl>
      <dl class="flex gap-m justify-between">
        <dt v-text="$t(`property.co_ownership.proceedings_underway`)" />
        <dd v-text="proceedingsUnderway" />
      </dl>
    </div>
  </section>
</template>
